import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { CheckoutErrorCode } from '@jane/shared/data-access';
import {
  CHECKOUT_ERROR_CODES,
  checkoutErrorDetails,
} from '@jane/shared/data-access';

const reward = (title?: string | null) =>
  title ? `The ${title} reward` : 'Your Jane Gold cash back reward';

const MESSAGES: Record<CheckoutErrorCode, (title?: string | null) => string> = {
  [CHECKOUT_ERROR_CODES.brandSpecialBudgetExhausted]: (title) =>
    `Your order wasn't placed. ${reward(
      title
    )} isn't available for this order and has been removed. This order won't earn Jane Gold cash back. Your order total hasn't changed and you haven't been charged.`,
};

const CART_CHANGED = 'Your total has been updated';

export const checkoutErrorCopy = (error: unknown): string | undefined => {
  const details = checkoutErrorDetails(error);

  return details ? MESSAGES[details.code]?.(details.title) : undefined;
};

/** Refetches the cart when a refusal changed it, and returns our copy for the refusal. */
export const useCheckoutRefusal = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (error: unknown) => {
      if (checkoutErrorDetails(error) || String(error).includes(CART_CHANGED)) {
        queryClient.invalidateQueries({ queryKey: ['cart'] });
        queryClient.invalidateQueries({ queryKey: ['posCart'] });
      }

      return checkoutErrorCopy(error);
    },
    [queryClient]
  );
};
